import { render } from "./VideoPlayer.vue?vue&type=template&id=bf31a624"
import script from "./VideoPlayer.vue?vue&type=script&lang=ts"
export * from "./VideoPlayer.vue?vue&type=script&lang=ts"

import "./VideoPlayer.vue?vue&type=style&index=0&id=bf31a624&lang=scss"
script.render = render

export default script